import React from "react";
import {
  Box,
  Typography,
  TextField,
  Dialog,
  DialogContent,
  IconButton,
  styled,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomButton from "../../Common/CustomButton";

const BizdevModal: React.FC<ProfileLinkModalProps> = ({
  open,
  onClose,
  onSubmit,
  linkedin,
  upwork,
  setLinkedin,
  setUpwork,
  isValidLinkedInUrl,
  isValidUpworkUrl,
}) => {
  return (
    <StyledDialog open={open} onClose={onClose}>
      <DialogContent sx={{ padding: 0 }}>
        <Box display="flex" justifyContent="flex-end">
          <IconButton onClick={onClose} size="small" sx={{ color: "#fff" }}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Typography
          sx={{
            fontSize: "14px",
            mb: "12px",
            fontWeight: 700,
            lineHeight: "20px",
          }}
        >
          LinkedIn profile
        </Typography>
        <StyledTextField
          placeholder="LinkedIn Profile link"
          fullWidth
          value={linkedin}
          onChange={(e) => setLinkedin(e.target.value)}
          error={!!linkedin && !isValidLinkedInUrl(linkedin)}
          helperText={
            linkedin && !isValidLinkedInUrl(linkedin)
              ? "Enter a valid LinkedIn profile URL"
              : ""
          }
        />

        <Typography sx={{ color: "#fff", fontWeight: 500, mb: 1 }}>
          Upwork profile
        </Typography>
        <StyledTextField
          placeholder="Upwork Profile link"
          fullWidth
          value={upwork}
          onChange={(e) => setUpwork(e.target.value)}
          error={!!upwork && !isValidUpworkUrl(upwork)}
          helperText={
            upwork && !isValidUpworkUrl(upwork)
              ? "Enter a valid Upwork profile URL"
              : ""
          }
        />

        <Typography
          variant="body2"
          sx={{
            color: "#B7B7B7",
            mb: "28px",
            fontSize: "14px",
            fontWeight: 400,
            lineHeight: "20px",
          }}
        >
          We need at least one of your profile links to be able to apply.
        </Typography>
        <Box style={{ display: "flex", justifyContent: "end" }}>
          <CustomButton size="medium" onClick={onSubmit}>
            Apply
          </CustomButton>
        </Box>
      </DialogContent>
    </StyledDialog>
  );
};

export default BizdevModal;

const StyledDialog = styled(Dialog)(({ theme }) => ({
  color: "#fefefe",
  "& .MuiPaper-root": {
    backgroundColor: "#1E1E1E",
    padding: "20px",
    borderRadius: 20,
    width: "582px",
  },
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  backgroundColor: "#1e1e1e",
  borderRadius: "10px",
  marginBottom: "16px",
  "& .MuiOutlinedInput-root": {
    padding: 0,
    "& input": {
      padding: "12px",
      color: "#fff",
      "&::placeholder": {
        color: "#707070",
        opacity: 1,
      },
    },
    "& fieldset": {
      borderColor: "#333",
      borderWidth: "1px",
    },
    "&:hover fieldset": {
      borderColor: "#888",
    },
    "&.Mui-focused fieldset": {
      borderColor: "grey",
      borderWidth: "1px",
    },
    "& input:-webkit-autofill": {
      boxShadow: "0 0 0 1000px #1e1e1e inset !important",
      WebkitTextFillColor: "#fff !important",
      borderRadius: "10px",
    },
  },
}));

interface ProfileLinkModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
  linkedin: string;
  upwork: string;
  setLinkedin: (value: string) => void;
  setUpwork: (value: string) => void;
  isValidLinkedInUrl: (url: string) => boolean;
  isValidUpworkUrl: (url: string) => boolean;
}
